<template>
  <div class="tw-absolute tw-right-0 tw-top-0 tw-z-50">
    <IconButton @click="(e) => $emit('click', e)">
      <CloseIcon class="tw-text-[#111827] tw-text-xl" />
    </IconButton>
  </div>
</template>

<script>
import CloseIcon from 'vue-material-design-icons/Close'
import IconButton from '@/components/shared/IconButton'

export default {
  components: {
    CloseIcon,
    IconButton,
  },
}
</script>
